import React, { useEffect, useState } from "react";
import { Volume2, VolumeX, Play } from "lucide-react";
import { Switch } from "./ui/switch";
import { isChimeMuted, setChimeMuted, playChime, getChimeVolume, setChimeVolume, VOLUMES } from "../lib/chime";
import { useAuth } from "../context/AuthContext";

const LEVELS = Object.keys(VOLUMES); // soft / medium / loud

// Per-device sound preferences (same flags the "Mute chime" toast action and the chimes use).
const SoundSettings = () => {
  const { user } = useAuth();
  const [on, setOn] = useState(() => !isChimeMuted());
  const [level, setLevel] = useState(getChimeVolume);
  useEffect(() => {
    const sync = (e) => { if (e.key === "tycc_chime_muted") setOn(!isChimeMuted()); if (e.key === "tycc_chime_volume") setLevel(getChimeVolume()); };
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);
  if (!user) return null;

  const toggle = (v) => { setChimeMuted(!v); setOn(v); if (v) playChime(); };
  const pick = (l) => { setChimeVolume(l); setLevel(l); playChime(); };

  return (
    <section id="sounds" className="mt-10 rounded-3xl border-2 border-[#d7f2e3] bg-[#eefaf3] p-6" data-testid="sound-settings">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <span className="w-12 h-12 rounded-2xl bg-white text-[#2e8b57] flex items-center justify-center flex-shrink-0">{on ? <Volume2 /> : <VolumeX />}</span>
        <div className="flex-1">
          <h2 className="text-lg font-bold text-[#0c4a6e]" style={{ fontFamily: "Literata, serif" }}>Sounds</h2>
          <p className="text-sm text-[#0c4a6e]/80 mt-1">A soft chime when offline progress finishes saving, a tiny pop when a queued cheer lands, and a cheerful jingle when a new sticker unlocks. Remembered on this device only.</p>
          {on && (
            <div className="mt-3 flex flex-wrap items-center gap-2" data-testid="sound-volume">
              <span className="text-xs font-bold text-[#0c4a6e]/70 uppercase tracking-wider">Volume</span>
              {LEVELS.map((l) => (
                <button key={l} type="button" onClick={() => pick(l)} aria-pressed={level === l} className={`rounded-full px-3 py-1 text-xs font-bold capitalize transition-colors ${level === l ? "bg-[#2e8b57] text-white" : "bg-white text-[#2e8b57] border border-[#bfe6d0] hover:bg-[#dff3e8]"}`} data-testid={`sound-volume-${l}`}>{l}</button>
              ))}
            </div>
          )}
        </div>
        <div className="flex items-center gap-3">
          {on && <button type="button" onClick={playChime} className="inline-flex items-center gap-1 text-xs font-bold text-[#2e8b57] hover:underline" data-testid="sound-preview"><Play size={12} /> Preview</button>}
          <Switch checked={on} onCheckedChange={toggle} style={on ? { backgroundColor: "#2e8b57" } : {}} aria-label="Chime on or off" data-testid="sound-toggle" />
        </div>
      </div>
    </section>
  );
};

export default SoundSettings;
